import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * Único bloque de precio de la landing: precio anterior tachado en topo,
 * etiqueta de oferta en frambuesa y precio vigente grande en chocolate.
 */
export function PriceBlock({
  className = '',
  size = 'md'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3rem] sm:text-[3.6rem]' : 'text-[2.6rem] sm:text-[3.1rem]';
  return <div className={`flex flex-col items-center ${className}`} data-id="element-280" data-mp="1k4cjjt8292cd">
      <div className="flex items-center gap-2.5" data-id="element-281" data-mp="1g64zaoee1iwf">
        <p className="font-sans text-sm font-medium tabular-nums text-taupe sm:text-base" style={{
        textDecoration: 'line-through'
      }} data-id="element-282" data-mp="1tw8hn4a5csgl">
          {PRICE.previous}
        </p>
        <span className="rounded-full bg-gold px-2.5 py-0.5 font-display text-[0.62rem] font-bold uppercase tracking-[0.1em] text-white" data-id="element-283" data-mp="11fxq6za9tc8e">
          Oferta
        </span>
      </div>
      <p className={`mt-1 font-display font-extrabold leading-[0.95] tracking-tight tabular-nums text-charcoal ${current}`} data-id="element-284" data-mp="werucslbd8un">
        {PRICE.current}
      </p>
      <p className="mt-2 font-sans text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-taupe" data-id="element-285" data-mp="1wx9xltsbdmct">
        {PRICE.note}
      </p>
    </div>;
}